<template>
  <div class="container-fluid d-print-none">
    <div class="row py-1 align-items-center">

      <div class="col-lg-1  text-center text-lg-left">
        <m-a :href="{name:'Home'}">
          <img :src="findAttributeOnSiteInfo('icon')[0]" :alt="$t('site.name')" class="nav-logo"/>
        </m-a>
      </div>

      <div class="col-lg-4 text-center text-lg-right py-2">
        <m-a :href="{name:'Home'}" class="" v-t="`site.name`"></m-a>
      </div>


      <div class="col-lg-3 align-self-center text-center">
        <div class="bg-white nav303-search">

          <form @submit.prevent="search()">
            <i @click="search()" class="bi bi-search search-icon"/>
            <input :placeholder="$t('nav.search_placeholder')" type="text" v-model.trim="searchWord"
                   class="py-1  border-0">
          </form>
        </div>
      </div>

      <div class="col-lg-4 text-center text-lg-left py-1 ">

        <m-menu3 class="d-inline-block nav303-menu" :menu-position="menuPosition">

          <div class="base-menu-item-wrapper">
            <m-base-menu-item item-icon="cart-fill" v-if="shoppingCart" :item-link="shoppingCartLink"
                              :item-text="$t(`nav.shopping_cart`)"/>
            <m-shopping-cart-counter1 class="position-absolute"/>
          </div>
        </m-menu3>
      </div>


    </div>
  </div>
</template>
<script>
import router from "@/router";
import {mapGetters} from "vuex";
import {MenuProps} from "../../Menu/MenuProps";
import {NavComputed} from "../NavComputed";
import mA from '../../Tags/A'
import mIcon from '../../Icons/Icon'
import mMenu3 from "../../Menu/Menu3";
import mBaseMenuItem from "../../Menu/BaseMenuItem";
import mShoppingCartCounter1 from "../../ShoppingCart/ShoppingCartCounter/ShoppingCartCounter1";

export default {
  name: "Nav303",
  props: {
    shoppingCart: {
      type: Boolean,
      default: true,
    },
    ...MenuProps,
  },
  components: {mA, mIcon, mMenu3, mBaseMenuItem, mShoppingCartCounter1},
  data() {
    return {
      shoppingCartCount: 0,
      searchWord: '',
    };
  },
  computed: {
    ...mapGetters({
      storeMenus: "Menu/getAllMenus",
      isAuth: "User/isAuthenticated",
      orderCount: 'ShoppingCart/getSidebarBasketData',
    }),
    ...NavComputed,
  },
  methods: {
    search() {
      router.push({name: 'Search', params: {words: this.searchWord, type: 'product'}})
    },
  },
};
</script>

<style>
.nav303-menu .base-menu-item-icon {
  font-size: 25px;
}
</style>

<style scoped>
.nav-logo {
  height: 80px;
  margin-top: 3px;
}

.navbar-brand img {
  height: 45px;
}

.nav303-search .search-icon {
  margin: 7px 0 0 5px;
  font-size: 20px !important;
}

.nav303-search input {
  width: 90%
}

.nav303-search input:focus {
  border: none !important;
  outline: none;
}

.nav303-item > a {
  vertical-align: middle;
}

.nav303-search {
  padding: 8px 0;
}

:deep(.shopping-cart-counter-1) {
  top: 10px;
  left: 10px;
}

</style>